import React, { useState } from 'react';
import { Sidebar, BottomNav } from './components/Navigation';
import { Dashboard } from './views/Dashboard';
import { MealBoard } from './views/MealBoard';
import { Recipes } from './views/Recipes';
import { Pantry } from './views/Pantry';
import { Settings } from './views/Settings';
import { Demo } from './views/Demo';

function App() {
  const [activeTab, setActiveTab] = useState('dashboard');

  const renderView = () => {
    switch (activeTab) {
      case 'dashboard': return <Dashboard setActiveTab={setActiveTab} />;
      case 'board': return <MealBoard />;
      case 'recipes': return <Recipes />;
      case 'pantry': return <Pantry />;
      case 'demo': return <Demo />;
      case 'settings': return <Settings />;
      default: return <Dashboard setActiveTab={setActiveTab} />;
    }
  };

  return (
    <div className="min-h-screen bg-cream-100 flex font-sans text-steel-900">
      <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
      
      <main className="flex-1 md:ml-64 pb-20 md:pb-0 min-h-screen overflow-x-hidden">
        {/* Mobile Header */}
        <div className="md:hidden bg-steel-900 text-cream-100 p-4 sticky top-0 z-40 shadow-md flex items-center justify-between font-mono px-6">
          <span className="tracking-widest text-lg font-bold">COOKCIRCUIT</span>
          <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></div>
        </div>

        <div className="p-4 md:p-8 max-w-7xl mx-auto h-full">
          {renderView()}
        </div>
      </main>

      <BottomNav activeTab={activeTab} setActiveTab={setActiveTab} />
    </div>
  );
}

export default App;